import { Create, Edit, List } from "../Components/index.js";

export default [
    {
        path: "/event/attendance",
        component: () => import("../Components/Attendance.vue"),
        name: "event-attendance",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/parade-state/attendance",
        component: List,
        name: "parade-attendance-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/parade-state/attendance/:parade_type_id/users",
        component: Create,
        name: "parade-attendance-create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/parade-state/attendance/:id/edit",
        component: Edit,
        name: "parade-attendance-edit",
        meta: {
            requiresAuth: true,
        },
    },
];
